let logoutTimer = null;

export const setupAutoLogout = (token, logoutCallback) => {
    if (!token || typeof token !== "string") {
        logoutCallback();
        return;
    }

    try {
        // 1️⃣ Check JWT format (header.payload.signature)
        const parts = token.split(".");
        if (parts.length !== 3) {
            throw new Error("Invalid JWT format");
        }

        // 2️⃣ Decode payload safely
        const payload = JSON.parse(atob(parts[1]));

        // 3️⃣ Check if exp exists
        if (!payload.exp) {
            throw new Error("Token has no expiry");
        }

        // 4️⃣ Clear previous timer
        if (logoutTimer) {
            clearTimeout(logoutTimer);
        }

        const expiryTime = payload.exp * 1000;
        const currentTime = Date.now();
        const timeout = expiryTime - currentTime;

        console.log(
            `Token expires in ${(expiryTime, payload.exp, currentTime, timeout)} seconds`,
        );
        // 5️⃣ If already expired
        if (timeout <= 0) {
            logoutCallback();
            return;
        }

        // 6️⃣ Setup auto logout
        logoutTimer = setTimeout(() => {
            logoutCallback();
        }, timeout);
    } catch (error) {
        console.error("Invalid token:", error.message);
        logoutCallback();
    }
};
